import {AbstractModel, JsonObject, JsonProperty} from 'projects/core/src/public-api';

@JsonObject('model.PricingMiscItemPreset')
export class PricingMiscItemPreset extends AbstractModel {
  @JsonProperty(Number, 'id')
  id?: number

  @JsonProperty(String, 'title')
  title?: string

  @JsonProperty(String, 'value')
  value?: string
}

